import React from 'react'

const RecoveryReport = () => {
  return (
    <div>RecoveryReport</div>
  )
}

export default RecoveryReport